module.exports = __webpack_public_path__ + "img/icon_instagram_crop.5b657183.svg";